import Loadable from 'react-loadable'

const hunaRoutes = [
  {
    path: '/hybrid/payment',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridPayment" */ '../pages/recharge/payment'
        ),
      loading: () => null,
    }),
  },
  {
    path: '/home_huna',
    exact: true,
    component: Loadable({
      loader: () =>
        import(/* webpackChunkName: "page-HomeX" */ '../pages/home_huna_lite'),
      loading: () => null,
    }),
  },
  {
    path: '/home',
    exact: true,
    component: Loadable({
      loader: () =>
        import(/* webpackChunkName: "page-HomeX" */ '../pages/home_huna'),
      loading: () => null,
    }),
  },
  {
    path: '/hybrid/coinsSeller',
    exact: true,
    component: Loadable({
      loader: () =>
        import(/* webpackChunkName: "page-hyBridCoinsSeller" */ '../pages/coinsSeller'),
      loading: () => null,
    }),
  },
  // 帐户删除策略
  {
    path: '/huna/about/memberDelete',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridAboutDpX" */ '../pages/aboutDp_huna'
        ),
      loading: () => null,
    }),
  },
  {
    path: '/hybrid/vip/description',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridVipDescription" */ '../pages/VipDesciption'
        ),
      loading: () => null,
    }),
  },
  {
    path: '/hybrid/vip/description/zh',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridVipDescriptionZh" */ '../pages/VipDesciption/VipDesciptionZh'
        ),
      loading: () => null,
    }),
  },
  {
    path: '/hybrid/vip/description/en',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridVipDescriptionEn" */ '../pages/VipDesciption/VipDesciptionEn'
        ),
      loading: () => null,
    }),
  },
  {
    path: '/hybrid/vip/description/ar',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridVipDescriptionAr" */ '../pages/VipDesciption/VipDescriptionAr'
        ),
      loading: () => null,
    }),
  },
  {
    path: '/hybrid/vip/description/tr',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridVipDescriptionTr" */ '../pages/VipDesciption/VipDescriptionTr'
        ),
      loading: () => null,
    }),
  },
  {
    path: '/hybrid/vip/description/id',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridVipDescriptionId" */ '../pages/VipDesciption/VipDesciptionId'
        ),
      loading: () => null,
    }),
  },
  {
    path: '/hybrid/vip/description/hi',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridVipDescriptionHi" */ '../pages/VipDesciption/VipDesciptionHi'
        ),
      loading: () => null,
    }),
  },
  {
    path: '/hybrid/vip/description/vi',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridVipDescriptionVn" */ '../pages/VipDesciption/VipDesciptionVi'
        ),
      loading: () => null,
    }),
  },
  // 用户协议
  {
    path: '/huna/about/userAgreement',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridAboutTsSocial" */ '../pages/aboutTs_huna'
        ),
      loading: () => null,
    }),
  },
  // 隐私政策
  {
    path: '/huna/about/privacyAgreement',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridAboutPpX" */ '../pages/aboutPp_huna'
        ),
      loading: () => null,
    }),
  },
  // 儿童协议
  {
    path: '/huna/about/childSexualAbusePolicy',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridAboutCsapX" */ '../pages/aboutCsap_huna'
        ),
      loading: () => null,
    }),
  },
  // 联系我们
  {
    path: '/huna/about/contactUs',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridAboutContact" */ '../pages/aboutContact_huna'
        ),
      loading: () => null,
    }),
  },
  {
    path: '/huna/about/contactUs/en',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridAboutContactEn" */ '../pages/aboutContact_huna/aboutContactEn'
        ),
      loading: () => null,
    }),
  },
  // 社区规则
  {
    path: '/huna/about/communityGuidelines',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridAboutCsapX" */ '../pages/aboutCg_huna'
        ),
      loading: () => null,
    }),
  },
  // 第三方sdk
  {
    path: '/huna/about/thirdPartySDK',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridAboutCsapX" */ '../pages/about3rd_huna'
        ),
      loading: () => null,
    }),
  },
  // 帮助
  {
    path: '/huna/help/qa',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridHelpQuestions" */ '../pages/helpQuestions_huna/helpQuestionsEn'
        ),
      loading: () => null,
    }),
  },
  {
    path: '/huna/help/qa/en',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridHelpQuestionsEn" */ '../pages/helpQuestions_huna/helpQuestionsEn'
        ),
      loading: () => null,
    }),
  },
  {
    path: '/huna/billboardRankRule',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridHelpQuestionsEn" */ '../pages/billboardRule_huna'
        ),
      loading: () => null,
    }),
  },
  {
    path: '/huna/familyRankRule',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridHelpQuestionsEn" */ '../pages/familyRule_huna'
        ),
      loading: () => null,
    }),
  },
  {
    path: '/huna/familyRankRule/ar',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridHelpQuestionsEn" */ '../pages/familyRule_huna/familyRuleAr'
        ),
      loading: () => null,
    }),
  },
  {
    path: '/huna/cpRankRule',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridHelpQuestionsEn" */ '../pages/cpRankRule'
        ),
      loading: () => null,
    }),
  },
  {
    path: '/huna/vipRule',
    exact: true,
    component: Loadable({
      loader: () =>
        import(
          /* webpackChunkName: "page-hybridHelpQuestionsEn" */ '../pages/VipDesciption_huna'
        ),
      loading: () => null,
    }),
  },
  // 订阅vip
  // {
  //     path: '/huna/vip/autoRenew',
  //     exact: true,
  //     component: Loadable({
  //         loader: () =>
  //             import(/* webpackChunkName: "page-hyBridVipAutoRenew" */ '../pages/vipAutoRenew'),
  //         loading: () => null,
  //     }),
  // },
  // {
  //     path: '/huna/vip/autoRenew/en',
  //     exact: true,
  //     component: Loadable({
  //         loader: () =>
  //             import(/* webpackChunkName: "page-hyBridVipAutoRenewEn" */ '../pages/vipAutoRenew/vipAutoRenewEn'),
  //         loading: () => null,
  //     }),
  // },
]

export default hunaRoutes
